import React, { Component } from 'react';
import { Switch, Route } from "react-router-dom";
import Home from '../components/home';
import ResortInformation from '../components/home/resorts/resortInfo';
class Main extends Component {
    render() {
        return (
            <div>
                <Switch>
                    <Route
                        exact path="/"
                        component={Home}
                    />
                    <Route
                        path="/resortInfo"
                        component={ResortInformation}
                    />
                </Switch>
            </div>
        );
    }
}

export default Main;